// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-content {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
}
.error-content_mobile {
  flex-direction: column;
}
.error-content_mobile .error-content__content {
  padding: 0 16px;
  width: 100%;
  text-align: center;
  align-items: center;
}
.error-content_mobile .error-content__title {
  width: 100%;
  text-align: center;
}
.error-content_mobile .error-content__title a {
  color: var(--g-color-text-link);
}
.error-content_mobile .error-content__title a:visited {
  color: var(--g-color-text-link);
}
.error-content_mobile .error-content__description {
  font-family: var(--g-text-body-font-family);
  font-weight: var(--g-text-body-font-weight);
  font-size: var(--g-text-body-2-font-size);
  line-height: var(--g-text-body-2-line-height);
}
.error-content_mobile .error-content__debug-info {
  width: auto;
}
.error-content_mobile .error-content__action-btn {
  margin-top: 0;
  width: 100%;
}
.error-content_mobile .error-content__illustration-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
}
.error-content_size_s .error-content__title {
  font-size: var(--g-text-body-1-font-size);
  line-height: var(--g-text-body-1-line-height);
}
.error-content_size_s .error-content__content {
  width: auto;
}
.error-content_no-controls {
  display: block;
  padding: 20px 0;
}
.error-content__title {
  font-weight: 500;
  font-size: var(--g-text-header-1-font-size);
  line-height: var(--g-text-header-1-line-height);
}
.error-content__title a {
  color: var(--g-color-text-link);
}
.error-content__title a:visited {
  color: var(--g-color-text-link);
}
.error-content__content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex-shrink: 0;
  width: 350px;
}
.error-content__action-btn {
  margin-top: 20px;
}
.error-content__description {
  margin-top: 10px;
}
.error-content__description a {
  color: var(--g-color-text-link);
}
.error-content__description a:visited {
  color: var(--g-color-text-link);
}
.error-content__debug-info {
  width: 500px;
  margin-top: 20px;
  color: var(--g-color-text-hint);
}
.error-content__copy-btn {
  margin-left: 10px;
}
.error-content__action {
  margin-top: 20px;
}
.error-content_layout_row {
  min-height: 320px;
}
.error-content_layout_row .error-content__content {
  margin-left: 40px;
}
.error-content_layout_column {
  flex-direction: column;
}
.error-content_layout_column .error-content__content {
  width: 400px;
  align-items: center;
  text-align: center;
}
.error-content__yfm {
  margin-top: 10px;
  font-size: var(--g-text-body-1-font-size);
}
.error-content__yfm_without-title {
  margin-top: 0;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/ErrorContent/ErrorContent.scss","webpack://./node_modules/@gravity-ui/uikit/styles/mixins.scss"],"names":[],"mappings":"AAEA;EAEI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AAFJ;AAII;EACI,sBAAA;AAFR;AAIQ;EACI,eAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;AAFZ;AAKQ;EACI,WAAA;EACA,kBAAA;AAHZ;AAKY;EACI,+BAAA;AAHhB;AAKgB;EACI,+BAAA;AAHpB;AAQQ;EC8IJ,2CAAA;EACA,2CAAA;EACA,yCAAA;EACA,6CAAA;ADnJJ;AAMQ;EACI,WAAA;AAJZ;AAOQ;EACI,aAAA;EACA,WAAA;AALZ;AAQQ;EACI,OAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;AANZ;AAWQ;EACI,yCAAA;EACA,6CAAA;AATZ;AAYQ;EACI,WAAA;AAVZ;AAcI;EACI,cAAA;EACA,eAAA;AAZR;AAeI;EACI,gBAAA;EACA,2CAAA;EACA,+CAAA;AAbR;AAeQ;EACI,+BAAA;AAbZ;AAeY;EACI,+BAAA;AAbhB;AAkBI;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,cAAA;EAEA,YAAA;AAjBR;AAoBI;EACI,gBAAA;AAlBR;AAqBI;EACI,gBAAA;AAnBR;AAqBQ;EACI,+BAAA;AAnBZ;AAqBY;EACI,+BAAA;AAnBhB;AAwBI;EACI,YAAA;EACA,gBAAA;EACA,+BAAA;AAtBR;AAyBI;EACI,iBAAA;AAvBR;AA0BI;EACI,gBAAA;AAxBR;AA4BQ;EACI,iBAAA;AA1BZ;AA4BY;EACI,iBAAA;AA1BhB;AA8BQ;EACI,sBAAA;AA5BZ;AA8BY;EACI,YAAA;EACA,mBAAA;EACA,kBAAA;AA5BhB;AAiCI;EACI,gBAAA;EACA,yCAAA;AA/BR;AAiCQ;EACI,aAAA;AA/BZ","sourcesContent":[".error-content {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-grow: 1;\n}\n.error-content_mobile {\n  flex-direction: column;\n}\n.error-content_mobile .error-content__content {\n  padding: 0 16px;\n  width: 100%;\n  text-align: center;\n  align-items: center;\n}\n.error-content_mobile .error-content__title {\n  width: 100%;\n  text-align: center;\n}\n.error-content_mobile .error-content__title a {\n  color: var(--g-color-text-link);\n}\n.error-content_mobile .error-content__title a:visited {\n  color: var(--g-color-text-link);\n}\n.error-content_mobile .error-content__description {\n  font-family: var(--g-text-body-font-family);\n  font-weight: var(--g-text-body-font-weight);\n  font-size: var(--g-text-body-2-font-size);\n  line-height: var(--g-text-body-2-line-height);\n}\n.error-content_mobile .error-content__debug-info {\n  width: auto;\n}\n.error-content_mobile .error-content__action-btn {\n  margin-top: 0;\n  width: 100%;\n}\n.error-content_mobile .error-content__illustration-container {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  width: 100%;\n}\n.error-content_size_s .error-content__title {\n  font-size: var(--g-text-body-1-font-size);\n  line-height: var(--g-text-body-1-line-height);\n}\n.error-content_size_s .error-content__content {\n  width: auto;\n}\n.error-content_no-controls {\n  display: block;\n  padding: 20px 0;\n}\n.error-content__title {\n  font-weight: 500;\n  font-size: var(--g-text-header-1-font-size);\n  line-height: var(--g-text-header-1-line-height);\n}\n.error-content__title a {\n  color: var(--g-color-text-link);\n}\n.error-content__title a:visited {\n  color: var(--g-color-text-link);\n}\n.error-content__content {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  flex-shrink: 0;\n  width: 350px;\n}\n.error-content__action-btn {\n  margin-top: 20px;\n}\n.error-content__description {\n  margin-top: 10px;\n}\n.error-content__description a {\n  color: var(--g-color-text-link);\n}\n.error-content__description a:visited {\n  color: var(--g-color-text-link);\n}\n.error-content__debug-info {\n  width: 500px;\n  margin-top: 20px;\n  color: var(--g-color-text-hint);\n}\n.error-content__copy-btn {\n  margin-left: 10px;\n}\n.error-content__action {\n  margin-top: 20px;\n}\n.error-content_layout_row {\n  min-height: 320px;\n}\n.error-content_layout_row .error-content__content {\n  margin-left: 40px;\n}\n.error-content_layout_column {\n  flex-direction: column;\n}\n.error-content_layout_column .error-content__content {\n  width: 400px;\n  align-items: center;\n  text-align: center;\n}\n.error-content__yfm {\n  margin-top: 10px;\n  font-size: var(--g-text-body-1-font-size);\n}\n.error-content__yfm_without-title {\n  margin-top: 0;\n}",null],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
